export const CHART_OF_ACCOUNTS = [
  {
    "id": "1-10001",
    "name": "Kas",
    "category": "Cash & Bank"
  },
  {
    "id": "1-10002",
    "name": "Rekening ASB",
    "category": "Cash & Bank"
  },
  {
    "id": "1-10003",
    "name": "Rekening CJT",
    "category": "Cash & Bank"
  },
  {
    "id": "1-10004",
    "name": "Rekening SDE",
    "category": "Cash & Bank"
  },
  {
    "id": "1-10100",
    "name": "Piutang Usaha",
    "category": "Accounts Receivable (A/R)"
  },
  {
    "id": "1-10101",
    "name": "Piutang Belum Ditagih",
    "category": "Accounts Receivable (A/R)"
  },
  {
    "id": "1-10102",
    "name": "Piutang Lain-lain",
    "category": "Accounts Receivable (A/R)"
  },
  {
    "id": "1-10200",
    "name": "Persediaan Barang",
    "category": "Inventory"
  },
  {
    "id": "1-10300",
    "name": "Piutang Lainnya",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10301",
    "name": "Piutang Karyawan",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10400",
    "name": "Dana Belum Disetor",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10401",
    "name": "Uang Muka Pembelian",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10402",
    "name": "Biaya Dibayar Di Muka",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10403",
    "name": "Uang Muka Supplier / Lebih Bayar",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10500",
    "name": "PPN Masukan",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10501",
    "name": "Pajak Dibayar Di Muka - PPh 22",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10502",
    "name": "Pajak Dibayar Di Muka - PPh 23",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10503",
    "name": "Pajak Dibayar Di Muka - PPh 25",
    "category": "Other Current Assets"
  },
  {
    "id": "1-10700",
    "name": "Aset Tetap - Tanah",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10701",
    "name": "Aset Tetap - Bangunan",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10702",
    "name": "Aset Tetap - Building Improvements",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10703",
    "name": "Aset Tetap - Kendaraan",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10704",
    "name": "Aset Tetap - Mesin & Peralatan",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10705",
    "name": "Aset Tetap - Perlengkapan Kantor",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10706",
    "name": "Aset Tetap - Aset Sewa Guna Usaha",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10707",
    "name": "Aset Tak Berwujud",
    "category": "Fixed Assets"
  },
  {
    "id": "1-10751",
    "name": "Akumulasi Penyusutan - Bangunan",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10752",
    "name": "Akumulasi Penyusutan - Building Improvements",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10753",
    "name": "Akumulasi penyusutan - Kendaraan",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10754",
    "name": "Akumulasi Penyusutan - Mesin & Peralatan",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10755",
    "name": "Akumulasi Penyusutan - Peralatan Kantor",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10756",
    "name": "Akumulasi Penyusutan - Aset Sewa Guna Usaha",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10757",
    "name": "Akumulasi Amortisasi",
    "category": "Depreciation & Amortization"
  },
  {
    "id": "1-10800",
    "name": "Investasi",
    "category": "Other Assets"
  },
  {
    "id": "2-20100",
    "name": "Hutang Usaha",
    "category": "Accounts Payable (A/P)"
  },
  {
    "id": "2-20101",
    "name": "Hutang Belum Ditagih",
    "category": "Accounts Payable (A/P)"
  },
  {
    "id": "2-20200",
    "name": "Hutang Lain Lain",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20201",
    "name": "Hutang Gaji",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20202",
    "name": "Hutang Deviden",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20203",
    "name": "Pendapatan Diterima Di Muka",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20205",
    "name": "Hutang Konsinyasi",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20301",
    "name": "Sarana Kantor Terhutang",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20302",
    "name": "Bunga Terhutang",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20399",
    "name": "Biaya Terhutang Lainnya",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20400",
    "name": "Hutang Bank",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20500",
    "name": "PPN Keluaran",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20501",
    "name": "Hutang Pajak - PPh 21",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20502",
    "name": "Hutang Pajak - PPh 22",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20503",
    "name": "Hutang Pajak - PPh 23",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20504",
    "name": "Hutang Pajak - PPN (KAP 411121-100)",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20599",
    "name": "Hutang Pajak Lainnya",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20600",
    "name": "Hutang dari Pemegang Saham",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20601",
    "name": "Kewajiban Lancar Lainnya",
    "category": "Other Current Liabilities"
  },
  {
    "id": "2-20700",
    "name": "Kewajiban Manfaat Karyawan",
    "category": "Long Term Liabilities"
  },
  {
    "id": "3-30000",
    "name": "Modal Saham",
    "category": "Equity"
  },
  {
    "id": "3-30001",
    "name": "Tambahan Modal Disetor",
    "category": "Equity"
  },
  {
    "id": "3-30100",
    "name": "Laba Ditahan",
    "category": "Equity"
  },
  {
    "id": "3-30200",
    "name": "Deviden",
    "category": "Equity"
  },
  {
    "id": "3-30300",
    "name": "Pendapatan Komprehensif Lainnya",
    "category": "Equity"
  },
  {
    "id": "3-30999",
    "name": "Ekuitas Saldo Awal",
    "category": "Equity"
  },
  {
    "id": "4-40000",
    "name": "Pendapatan",
    "category": "Income"
  },
  {
    "id": "4-40100",
    "name": "Diskon Penjualan",
    "category": "Income"
  },
  {
    "id": "4-40200",
    "name": "Penjualan Maklon",
    "category": "Income"
  },
  {
    "id": "4-40201",
    "name": "Penjualan BPOM; HAKI",
    "category": "Income"
  },
  {
    "id": "4-40202",
    "name": "Penghasilan Lain",
    "category": "Income"
  },
  {
    "id": "5-50100",
    "name": "Diskon Pembelian",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50200",
    "name": "Biaya Pembelian",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50300",
    "name": "Biaya Produksi",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50301",
    "name": "Alkohol",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50302",
    "name": "Bahan Baku",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50303",
    "name": "Sablon/Coloring",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50304",
    "name": "Bibit Parfum",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50305",
    "name": "Botol",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50306",
    "name": "Spray",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50307",
    "name": "Tutup",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50308",
    "name": "Sticker/Sablon",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50309",
    "name": "Label Barcode",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50310",
    "name": "Box",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50311",
    "name": "Pengemasan",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50312",
    "name": "BPOM",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50313",
    "name": "HAKI",
    "category": "Cost of Sales"
  },
  {
    "id": "5-50314",
    "name": "Jasa Packing",
    "category": "Cost of Sales"
  },
  {
    "id": "6-60000",
    "name": "Biaya Penjualan",
    "category": "Expenses"
  },
  {
    "id": "6-60001",
    "name": "Iklan & Promosi",
    "category": "Expenses"
  },
  {
    "id": "6-60002",
    "name": "Komisi & Fee",
    "category": "Expenses"
  },
  {
    "id": "6-60003",
    "name": "Bensin, Tol dan Parkir - Penjualan",
    "category": "Expenses"
  },
  {
    "id": "6-60004",
    "name": "Perjalanan Dinas - Penjualan",
    "category": "Expenses"
  },
  {
    "id": "6-60005",
    "name": "Komunikasi - Penjualan",
    "category": "Expenses"
  },
  {
    "id": "6-60006",
    "name": "Marketing Lainnya",
    "category": "Expenses"
  },
  {
    "id": "6-60100",
    "name": "Biaya Umum & Administratif",
    "category": "Expenses"
  },
  {
    "id": "6-60101",
    "name": "Gaji",
    "category": "Expenses"
  },
  {
    "id": "6-60102",
    "name": "Upah",
    "category": "Expenses"
  },
  {
    "id": "6-60103",
    "name": "Makanan & Transportasi",
    "category": "Expenses"
  },
  {
    "id": "6-60104",
    "name": "Lembur",
    "category": "Expenses"
  },
  {
    "id": "6-60105",
    "name": "Pengobatan",
    "category": "Expenses"
  },
  {
    "id": "6-60106",
    "name": "THR & Bonus",
    "category": "Expenses"
  },
  {
    "id": "6-60107",
    "name": "Jamsostek",
    "category": "Expenses"
  },
  {
    "id": "6-60108",
    "name": "Insentif",
    "category": "Expenses"
  },
  {
    "id": "6-60109",
    "name": "Pesangon",
    "category": "Expenses"
  },
  {
    "id": "6-60110",
    "name": "Manfaat dan Tunjangan Lain",
    "category": "Expenses"
  },
  {
    "id": "6-60200",
    "name": "Donasi",
    "category": "Expenses"
  },
  {
    "id": "6-60201",
    "name": "Hiburan",
    "category": "Expenses"
  },
  {
    "id": "6-60202",
    "name": "Bensin, Tol dan Parkir - Umum",
    "category": "Expenses"
  },
  {
    "id": "6-60203",
    "name": "Perbaikan & Pemeliharaan",
    "category": "Expenses"
  },
  {
    "id": "6-60204",
    "name": "Perjalanan Dinas - Umum",
    "category": "Expenses"
  },
  {
    "id": "6-60205",
    "name": "Makanan",
    "category": "Expenses"
  },
  {
    "id": "6-60206",
    "name": "Komunikasi - Umum",
    "category": "Expenses"
  },
  {
    "id": "6-60207",
    "name": "Iuran & Langganan",
    "category": "Expenses"
  },
  {
    "id": "6-60208",
    "name": "Asuransi",
    "category": "Expenses"
  },
  {
    "id": "6-60209",
    "name": "Legal & Profesional",
    "category": "Expenses"
  },
  {
    "id": "6-60210",
    "name": "Beban Manfaat Karyawan",
    "category": "Expenses"
  },
  {
    "id": "6-60211",
    "name": "Sarana Kantor",
    "category": "Expenses"
  },
  {
    "id": "6-60212",
    "name": "Pelatihan & Pengembangan",
    "category": "Expenses"
  },
  {
    "id": "6-60213",
    "name": "Beban Piutang Tak Tertagih",
    "category": "Expenses"
  },
  {
    "id": "6-60214",
    "name": "Pajak dan Perizinan",
    "category": "Expenses"
  },
  {
    "id": "6-60215",
    "name": "Denda",
    "category": "Expenses"
  },
  {
    "id": "6-60216",
    "name": "Beban Administrasi Bank",
    "category": "Expenses"
  },
  {
    "id": "6-60217",
    "name": "Listrik",
    "category": "Expenses"
  },
  {
    "id": "6-60218",
    "name": "Air",
    "category": "Expenses"
  },
  {
    "id": "6-60219",
    "name": "Internet & Telepon",
    "category": "Expenses"
  },
  {
    "id": "6-60220",
    "name": "Langganan Software",
    "category": "Expenses"
  },
  {
    "id": "6-60300",
    "name": "Beban Kantor",
    "category": "Expenses"
  },
  {
    "id": "6-60301",
    "name": "Alat Tulis Kantor & Printing",
    "category": "Expenses"
  },
  {
    "id": "6-60302",
    "name": "Bea Materai",
    "category": "Expenses"
  },
  {
    "id": "6-60303",
    "name": "Keamanan dan Kebersihan",
    "category": "Expenses"
  },
  {
    "id": "6-60304",
    "name": "Supplies dan Material",
    "category": "Expenses"
  },
  {
    "id": "6-60305",
    "name": "Pemborong",
    "category": "Expenses"
  },
  {
    "id": "6-60400",
    "name": "Biaya Sewa - Bangunan",
    "category": "Expenses"
  },
  {
    "id": "6-60401",
    "name": "Biaya Sewa - Kendaraan",
    "category": "Expenses"
  },
  {
    "id": "6-60402",
    "name": "Biaya Sewa - Operasional",
    "category": "Expenses"
  },
  {
    "id": "6-60403",
    "name": "Biaya Sewa - Lain - lain",
    "category": "Expenses"
  },
  {
    "id": "6-60500",
    "name": "Penyusutan - Bangunan",
    "category": "Expenses"
  },
  {
    "id": "6-60501",
    "name": "Penyusutan - Perbaikan Bangunan",
    "category": "Expenses"
  },
  {
    "id": "6-60502",
    "name": "Penyusutan - Kendaraan",
    "category": "Expenses"
  },
  {
    "id": "6-60503",
    "name": "Penyusutan - Mesin & Peralatan",
    "category": "Expenses"
  },
  {
    "id": "6-60504",
    "name": "Penyusutan - Peralatan Kantor",
    "category": "Expenses"
  },
  {
    "id": "6-60599",
    "name": "Penyusutan - Aset Sewa Guna Usaha",
    "category": "Expenses"
  },
  {
    "id": "6-60216",
    "name": "Pengeluaran Barang Rusak",
    "category": "Expenses"
  },
  {
    "id": "7-70000",
    "name": "Pendapatan Bunga - Bank",
    "category": "Other Income"
  },
  {
    "id": "7-70001",
    "name": "Pendapatan Bunga - Deposito",
    "category": "Other Income"
  },
  {
    "id": "7-70002",
    "name": "Pendapatan Komisi - Barang Konsinyasi",
    "category": "Other Income"
  },
  {
    "id": "7-70003",
    "name": "Pembulatan",
    "category": "Other Income"
  },
  {
    "id": "7-70099",
    "name": "Pendapatan Lain - lain",
    "category": "Other Income"
  },
  {
    "id": "8-80000",
    "name": "Beban Bunga",
    "category": "Other Expense"
  },
  {
    "id": "8-80001",
    "name": "Provisi",
    "category": "Other Expense"
  },
  {
    "id": "8-80002",
    "name": "(Laba)/Rugi Pelepasan Aset Tetap",
    "category": "Other Expense"
  },
  {
    "id": "8-80100",
    "name": "Penyesuaian Persediaan",
    "category": "Other Expense"
  },
  {
    "id": "8-80999",
    "name": "Beban Lain - lain",
    "category": "Other Expense"
  },
  {
    "id": "9-90000",
    "name": "Beban Pajak - Kini",
    "category": "Other Expense"
  },
  {
    "id": "9-90001",
    "name": "Beban Pajak - Tangguhan",
    "category": "Other Expense"
  }
];
